import React, { useEffect, useState } from "react";
import { Modal, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { uniq } from "lodash";
import { AlertCircle } from "react-feather";
import { updateKeywords } from "../../store/actions/keywordActions";
import { updateTags } from "../../store/actions/domainActions";
import TagsSelect from "./TagsSelect";

const UpdateTagsModal = ({ keyword }) => {
  const dispatcher = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [keywordTitle, setKeywordTitle] = useState(null);
  const [keywordContent, setKeywordContent] = useState(null);
  const [isConfirmable, setIsConfirmable] = useState(true);
  const [tags, setTags] = useState([]);
  const isLoading = useSelector((state) => state.config.disableButton);
  const keywordsObj = useSelector((state) => state.keywords);
  const domains = useSelector((state) => state.domains.domains);
  const currentDomain = useSelector((state) => state.domains.currentDomain);
  const [manualKeywordsForm] = Form.useForm();

  useEffect(() => {
    if (keyword) {
      keyword.tags.length > 0 ? setTags(keyword.tags) : null;
      setIsConfirmable(false);
      setKeywordTitle(`Update tags for ${keyword.keyword}.`);
    } else if (keywordsObj.removals.length > 0) {
      setIsConfirmable(false);
      setKeywordTitle(
        `Update tags for ${keywordsObj.removals.length} keyword${
          keywordsObj.removals.length > 1 ? "s" : ""
        }.`
      );
      setKeywordContent(
        `This will override tags for ${keywordsObj.removals.length} keyword${
          keywordsObj.removals.length > 1 ? "s" : ""
        }, which will be permanent.`
      );
    } else {
      setKeywordTitle("Please select keywords to be removed.");
      setKeywordContent(
        "By clicking on the checkboxes you can select keywords."
      );
    }
  }, [keywordsObj]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const onFinish = (values) => {
    const tags = uniq(
      values.tags.map((tag) => {
        return tag.toLowerCase();
      })
    );
    const keywordIds = keyword ? keyword._id : keywordsObj.removals.join(",");
    
    dispatcher(
      updateKeywords(
        currentDomain._id,
        keywordIds,
        tags,
        setIsModalVisible,
        keywordsObj.pageNum,
        keywordsObj.search,
        keywordsObj.sort,
        keywordsObj.limit
      )
    );
    dispatcher(updateTags(domains, currentDomain._id, tags));
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <a className="dim-anchor" onClick={showModal}>
        Edit Tags
      </a>
      <Modal
        title={keywordTitle}
        visible={isModalVisible}
        onOk={() => manualKeywordsForm.submit()}
        onCancel={() => setIsModalVisible(false)}
        okText="Apply"
        keyboard={false}
        maskClosable={false}
        width={1000}
        okButtonProps={{
          disabled: isConfirmable,
          loading: isLoading,
        }}
        cancelButtonProps={{
          loading: isLoading,
        }}
      >
        <Form
          form={manualKeywordsForm}
          layout="vertical"
          name="addKeyworsForm"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{
            ["tags"]: tags,
          }}
        >
          <TagsSelect />
          {keywordContent && (
            <p className="mt-2 mb-1">
              <AlertCircle style={{ color: "#f5222d" }} /> {keywordContent}
            </p>
          )}
        </Form>
      </Modal>
    </>
  );
};

export default UpdateTagsModal;
